import { render, staticRenderFns } from "./empty-data.vue?vue&type=template&id=6750cd3b&"
import script from "./empty-data.vue?vue&type=script&lang=js&"
export * from "./empty-data.vue?vue&type=script&lang=js&"
import style0 from "./empty-data.vue?vue&type=style&index=0&id=6750cd3b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports